// File: src/firebase.js

import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCPPlnpWN5bWXxguGBemAAXdNxKMe0Wqks",
  authDomain: "qgriller.firebaseapp.com",
  projectId: "qgriller",
  storageBucket: "qgriller.firebasestorage.app",
  messagingSenderId: "460696354417",
  appId: "1:460696354417:web:f2ef99bb7a504e699465d0",
  measurementId: "G-6V5MJJ2WMH",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);

export default app;
